import React from 'react'
import Browse from './Browse'
import Login from './Login'
import { createBrowserRouter , RouterProvider} from 'react-router-dom'

const Body = () => {

  const appRouter = createBrowserRouter([
    {
      path : "/",
      element : <Login/>
    },
    {
      path : "/browse",
      element : <Browse/>
    }
  ])

  return (
    <div  className="scrollbar-hide overflow-auto">
      <RouterProvider router={appRouter}/>
    </div>
  )
}

export default Body